import { render, staticRenderFns } from "./SearchNijmegen.vue?vue&type=template&id=252e8f12&scoped=true&"
import script from "./SearchNijmegen.vue?vue&type=script&lang=js&"
export * from "./SearchNijmegen.vue?vue&type=script&lang=js&"
import style0 from "./SearchNijmegen.vue?vue&type=style&index=0&id=252e8f12&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "252e8f12",
  null
  
)

export default component.exports